module.exports = __webpack_public_path__ + "272cf54ac02c77dc9dbc179a23129db6.svg";